import React from "react";
import { ArrowDownIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { finalFlow } from "../../data/content";
export function FinalCta() {
  return <section className="bg-brand-950 px-4 py-16 md:py-24" aria-labelledby="final-title" data-id="element-128" data-mp="1nozqd7fngs78">
      <div className="mx-auto max-w-2xl text-center" data-id="element-129" data-mp="1nn59q5bevm8y">
        <h2 id="final-title" className="text-balance font-serif text-[1.9rem] font-black leading-tight text-white sm:text-4xl md:text-5xl" data-id="element-130" data-mp="1smrpaleppekx">
          Ready to stop organizing every case <em className="text-gold" data-id="element-131" data-mp="1iq56e25y4xlj">from scratch?</em>
        </h2>
        <p className="mt-4 text-[17px] leading-relaxed text-brand-100" data-id="element-132" data-mp="14q3ttpgbk1q8">
          You don't need another giant pile of theory. You need a clearer way to connect:
        </p>

        <ol className="mx-auto mt-8 max-w-sm" data-id="element-133" data-mp="19pgr744tgr72">
          {finalFlow.map((step, i) => <li key={step} className="flex flex-col items-center" data-id="element-134" data-mp="2z4oa7pxlxb3t" data-mpi={i}>
              <span className="w-full rounded-xl bg-white px-4 py-3 text-[15px] font-extrabold uppercase tracking-wide text-brand-900" data-id="element-135" data-mp="343hqfq4a3g7o">
                {step}
              </span>
              {i < finalFlow.length - 1 && <ArrowDownIcon className="my-1 h-5 w-5 text-gold" aria-hidden="true" data-id="element-136" data-mp="3ted3hflvynwq" />}
            </li>)}
        </ol>

        <p className="mt-8 text-[17px] leading-relaxed text-white" data-id="element-137" data-mp="b0n9i2b5a5ee">
          That's exactly what the Sensory Decision Map™ was designed to help you organize.
        </p>
        <p className="mt-6 font-serif text-4xl font-black text-gold" data-id="element-138" data-mp="3fgof3xsm0ymx">Only USD $27</p>

        <div className="mt-6" data-id="element-139" data-mp="3ahbuljp7o3ni">
          <CtaButton dark label="Get the Sensory Decision Map™" note="Instant digital access · One-time payment · Lifetime access · 7-Day Guarantee" data-id="element-140" data-mp="3ai4t5xe0nmuk" />
        </div>
      </div>
    </section>;
}